<template>
	<div>
	<b-modal title="Shop Establishment" no-close-on-esc no-close-on-backdrop class="modal-info" size="lg" hide-footer v-model="largeModal" @ok="largeModal = false">
                <b-row>
                  <b-col sm="4">
                    <div class="form-group">
                      <label for="name">Shop Type<span style="color:red">*</span></label>
                      <select class="form-control" v-model="shoptype" ref="shptype">
                        <option selected readonly value="">Select Your Shop Type</option>
                        <option value="shop">Shop</option>
                        <option value="warehouse">Warehouse</option>
                      </select> 
                      <small  class="help-block" v-if="hasErrors.cmptype" ><strong style="color: red;">Enter Company  Type</strong></small>
                    </div>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name"> Shop Name <span class="star" style="color:red">*</span></label>
                      <b-form-input type="text" ref="txtshopname" @blur.native="chkShopExist()" v-model="shop.name" :class="{'is-invalid':hasErrors.shopnm}" autocomplete="off"  placeholder="Enter Shop Name" ></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.shopnm" ><strong style="color: red;">Enter Valid Shop Name</strong></small>
                      <small  class="form-text text-muted" v-if="hasErrors.shopnmexist === true" ><strong style="color: red;">Shop Name Already Exist</strong></small>
                    </b-form-group>
                  </b-col>
                   <b-col sm="4">
                    <b-form-group>
                      <label for="name">Address Line 1 <span class="star" style="color:red">*</span></label>
                      <b-form-input type="text" v-model="shop.address1" :class="{'is-invalid':hasErrors.shopad1}" autocomplete="off" placeholder="Enter Address Line 1"></b-form-input>
                    <small  class="form-text text-muted" v-if="hasErrors.shopad1" ><strong style="color: red;">Enter Valid Shop Address</strong></small>
                    </b-form-group>
                  </b-col>            
                </b-row>
                
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Address Line 2 </label>
                      <b-form-input type="text" v-model="shop.address2" :class="{'is-invalid':hasErrors.shopad2}" autocomplete="off"  placeholder="Enter Address Line 2"></b-form-input>
                      <small class="form-text text-muted" v-if="hasErrors.shopad2" ><strong style="color: red;">Enter Valid Shop Address</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Country <span class="star" style="color:red">*</span></label>
                      <model-list-select :list="conopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="country_name" option-text="country_name" v-model="con" placeholder="Select Country" @input="state1"></model-list-select>
                      <small  class="form-text text-muted" v-if="hasErrors.shopcntry" ><strong style="color: red;">Select Country</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">State <span class="star" style="color:red">*</span></label>
                      <model-list-select :list="stateopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="state_name" option-text="state_name" v-model="state" placeholder="Select State" @input="city1"></model-list-select>
                      <small class="form-text text-muted" v-if="hasErrors.shopstate" ><strong style="color: red;">Select State</strong></small>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">City <span class="star" style="color:red">*</span></label>
                      <model-list-select :list="cityopt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="city_name" option-text="city_name" v-model="city" placeholder="Select City"></model-list-select>
                      <small  class="form-text text-muted" v-if="hasErrors.shopcity" ><strong style="color: red;">Select City</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Pincode <span class="star" style="color:red">*</span></label>
                      <b-form-input type="text" v-model="shop.pincode" :class="{'is-invalid':hasErrors.shoppin}" autocomplete="off" placeholder="Enter your Pincode"></b-form-input>
                      <small class="form-text text-muted" v-if="hasErrors.shoppin" ><strong style="color: red;" >Enter Valid Pincode</strong></small>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">GST No. </label>
                      <b-form-input type="text"  v-model="shop.gst" onkeyup="this.value = this.value.toUpperCase();" :class="{'is-invalid':hasErrors.shop_gst}" autocomplete="off" placeholder="Enter Your GST No"></b-form-input>
                      <small  class="form-text text-muted" v-if="hasErrors.shop_gst" ><strong style="color: red;">Enter Valid GST No</strong></small>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Contact No. <span class="star" style="color:red">*</span></label>
                      <b-form-input type="text" v-model="shop.phone" :class="{'is-invalid':hasErrors.shopph}" autocomplete="off"  placeholder="Enter Shop Phone Number"></b-form-input>
                      <small class="form-text text-muted" v-if="hasErrors.shopph" ><strong style="color: red;">Enter Valid Phone Number</strong></small>
                    </b-form-group>
                  </b-col>
                  <!--
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Select Shop Admin <span class="star" style="color:red">*</span></label>
                      <model-list-select :list="useropt" class="form-control" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;" option-value="email" :custom-text="nameAndnumber" v-model="adminuser" placeholder="Select Shop Admin"></model-list-select>
                      <small class="form-text text-muted" v-if="hasErrors.shopadmin"><strong style="color: red;">Select Shop Admin</strong></small>
                    </b-form-group>
                  </b-col>
                -->
                  <b-col sm="4">
                    <b-form-group>
                      <label for="name">Locate your Address In Map </label></br>
                      <b-button type="button" variant="warning" @click="openwarning">Select Address In Map</b-button>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12">
                    <b-form-group>
                      <label for="name">Sale Price Editable <!--<span class="star" style="color:red">*</span>--> </label>
                      <input type="checkbox" autocomplete="off"  v-model="shop.sale_price_editable">
                      <!-- <b-form-input type="checkbox" v-model="shop.sale_price_editable"></b-form-input> -->
                    </b-form-group>
                  </b-col>
                </b-row>
                <div class="card-footer modal_footer">
                  <b-row>
                    <b-col sm="12">
                    <button type="submit" class="btn btn-sm btn-primary" @click.prevent="Successsub()"><i class="fa fa-dot-circle-o"> </i> &nbsp;Save</button>
                    </b-col>
                  </b-row>
                </div>
              </b-modal>
               <!-- </div> -->
               <!-- <div v-else-if="largeModal ==="> -->
               <b-modal title="Select Address" no-close-on-esc no-close-on-backdrop size="lg" hide-footer class="modal-warning" v-model="warningModal" @ok="warningModal = false" ok-variant="warning">
    <div>
      <label>Search Address<GmapAutocomplete @place_changed="setPlace"></GmapAutocomplete>
        <span v-if="buttosstat==0">
          <button  @click="usePlace">Add</button>
        </span>
        <span v-else>
          <label>Now you can drag Marker to your loacation</label>
        </span>
      </label>
      <label>
        <div v-if=" buttosstat==1">
          <button class="btn btn-primary btn-sm" @click="revertbck">save</button> 
        </div>
      </label>
      <br/>
      <gmap-map style="width: 100%; height: 300px;" :zoom="16" :center="center">
        <gmap-marker v-for="(marker, index) in markers" :key="index" :position="marker.position" :clickable="true" :draggable="true" @click="center=marker.position" @dragend="getMarkerPosition($event.latLng)"/><gmap-marker v-if="this.place" label="★" :position="{lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng()}"></gmap-marker>
      </gmap-map>
    </div>
  </b-modal>
  <Spinner v-if="loading"></Spinner>
   </div>
</template>
<script>
import shopModal from '../../shop_plugins.js';
import Spinner from '../../spinner.vue'
import {mapState} from 'vuex'
export default {
  name:'shop',
  components: {Spinner},
  data() {
    return {
       center:{lat: 19.283442, lng: 72.870092},
      largeModal1:false,
      largeModal:false,
      loading:false,
      cityopt:[],
      stateopt:[],
      conopt:[],
      // useropt:[],
      citysrchopt:[],
      // adminuser:null,
      con:null,
      state:null,
      city:null,
      shoptype:[],
      editid:null,
      shopid:null, 
      shpusername:null,
      buttosstat:0,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1, 
        perPage: 10
      },
      shop:{
        name:'',
        phone:'',
        address1:'',
        address2:'',
        pincode:'',
        gst:'',
        sale_price_editable:false,
      },
      search:{
        name:'',
        city:null,
        address2:'',
        pincode:'',
      },
      columns: [
      {
        label: 'Shop Name', 
        field: 'est_shop_name',
        width: '40%'
      },
      {
        label: 'Shop Type',
        field: 'est_type',
        width: '20%'
      },
      {
        label: 'Shop Phone',
        field: 'est_shop_phone',
        width: '10%'
      },
      {
        label: 'Pincode',
        field: 'pincode',
        width: '10%'
      },
      {
        label: 'City',
        field: 'cities.city_name',
        width: '10%'
      },
      {
        label: 'Action',
        field: 'action',
        width: '10%'
      },
      ],
      rows: [],
      hasErrors:{
        message:false,  
        shopnm:false,
        shopad1:false, 
        shopad2:false,
        shoppin:false,
        shop_gst:false,
        shopph:false,
        shopcntry:false,
        shopstate:false,
        shopcity:false,
        cmptype:false,
        shopadmin:false,
        shopnmexist:false,
      },
      errorMessage:{
        message:''
      },
      warningModal: false,
      markers: [{ position: null }],
      place: null,
    }
  },

   mounted: function() {
      if(navigator.geolocation) {
        var self = this;
        navigator.geolocation.getCurrentPosition(function(position){
          self.center={
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          }
          self.markers.push({
            position: {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            }
          })
        })
      }
    },

    methods: {

    	// capitalize(str) {
     //      return str.replace(/(?:^|\s)\S/g, function(a) { return a.toUpperCase(); });
     //  },

      chkShopExist(){
        // console.log(this.shop.name)
        var _this = this
        // this.shop.name = this.capitalize(this.shop.name)
        // console.log(this.shop.name)
        if(this.shop.name != ''){
          this.$http.get('/api/shopestablishments/chk_shop_exist?filter[where][est_shop_name]='+this.shop.name).then(function (response) {
            if(response.data.length > 0){
              _this.shop.name = ''
              _this.hasErrors.shopnmexist = true
              _this.$refs['txtshopname'].focus()
            }
          })
          .catch(function(error){
            _this.hasErrors.shopnmexist = false
          });
        }
        else{
           _this.hasErrors.shopnmexist = false
        }
      },
      
      hide() {
      // method for closing modal
      this.largeModal = false;
    },
      nameAndnumber (item) {
        return `${item.username} - ${item.phone}`
      },

      // allusers(){
      //   var _this = this
      //   this.$http.get('/api/users/allusers').then(function(response){
      //     _this.useropt = response.data;
      //   }).catch(function(error){

      //   })
      // },

      shopuser(){
        var _this=this
        this.$http.get('/api/shopusers').then(function(response){

        }).catch(function(error){
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
          if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
            localStorage.clear();
            _this.$store.commit('SET_AUTH_USER', null)
            _this.$router.push('/');
          }
        })
      },

      fillshopgst(){
        var _this = this
        this.$http.get('/api/companies/findOne').then(function(response){
          _this.shop.gst=response.data.cmp_gst
        });
      },
      openwarning(){
        this.largeModal = false;
        this.warningModal = true;
        this.buttosstat=0;
      },

      // addshopnew(){
      //   var shopoptions = this.$refs.shptype.children;
      //   if (shopoptions.length) {
      //     this.shoptype = shopoptions[1].value;
      //   }
        
      //   this.hasErrors.cmptype='';
      //   this.hasErrors.shopnm= '';
      //   this.hasErrors.shopad1='';
      //   this.hasErrors.shopad2='';
      //   this.hasErrors.shoppin='';
      //   this.hasErrors.shop_gst='';
      //   this.hasErrors.shopph='';
      //   this.hasErrors.shopcntry='';
      //   this.hasErrors.shopadmin='';
      //   this.hasErrors.shopstate='';
      //   this.hasErrors.shopcity='';
      //   this.hasErrors.message='';
      //   this.hasErrors.shopnmexist='';
      //   this.errorMessage.message= '';
      //   this.shop.name='';
      //   this.shop.address1='';
      //   this.shop.address2='';
      //   this.shop.pincode='';
      //   this.shop.gst='';
      //   this.shop.phone='';
      //   this.updateedit=0;
      //   this.editid=null;
      //   this.shopid=null;
      //   this.shpusername=null;
      //   this.largeModal=true;
      //   this.contr1ed('101');
      //   this.state1ed('22');
      //   this.city1ed('2707');
      //   this.adminuser=null;
      //   this.fillshopgst();
      // },

      showShop(params) {
        // console.log(this.$refs.shptype)
      	// var shopoptions = this.$refs.shptype.children;
       //  if (shopoptions.length) {
          // this.shoptype = shopoptions[1].value;
       //  }
       // this.useropt = params['alluser']
       
        this.shoptype = 'shop'
        this.hasErrors.cmptype='';
        this.hasErrors.shopnm= '';
        this.hasErrors.shopad1='';
        this.hasErrors.shopad2='';
        this.hasErrors.shoppin='';
        this.hasErrors.shop_gst='';
        this.hasErrors.shopph='';
        this.hasErrors.shopcntry='';
        this.hasErrors.shopadmin='';
        this.hasErrors.shopstate='';
        this.hasErrors.shopcity='';
        this.hasErrors.message='';
        this.hasErrors.shopnmexist='';
        this.errorMessage.message= '';
        this.shop.name='';
        this.shop.address1='';
        this.shop.address2='';
        this.shop.pincode='';
        this.shop.gst='';
        this.shop.phone='';
        this.editid=null;
        this.shopid=null;
        this.shpusername=null;
        this.conopt = params['countries']
        // for(var i=0;i<this.useropt.length;i++){
        //   // console.log(i)
        //   if(this.useropt[i].role === '1'){
        //     this.adminuser=this.useropt[i]
        //   }
        // }
  	    this.fillshopgst();
        this.largeModal = true
	   },

      getMarkerPosition (marker) {
        this.center={lat:marker.lat(), lng:marker.lng()}
      },

      // contr1(){
      //   var _this=this
      //   this.$http.get('/api/countries').then(function(response){
      //     _this.conopt = response.data;
      //   }).catch(function(error){
      //     console.log("error.response")
      //   })
      // },

      state1(conopt){
        this.stateopt = [];
        this.cityopt=[];
        this.state =null
        this.city = null
        var _this=this
        var id=conopt.id
        this.$http.get('/api/states?filter[where][country_id]='+id).then(function(response){
          _this.stateopt=  response.data;
        }).catch(function(error){
          console.log(error)
        })
      },

      city1(stateopt){
        this.cityopt=[];
        this.city=null
        var _this=this
        var id=stateopt.id
        this.$http.get('/api/cities?filter[where][state_id]='+id).then(function(response){
          _this.cityopt=  response.data;
        }).catch(function(error){
          console.log(error)
        })
      },

      searchcity(name){
        var _this=this
        if(name.length > 2){
          this.$http.get('/api/cities?filter[where][city_name][ilike]=%'+name+'%').then(function (response) {
            _this.citysrchopt=response.data
          }).catch(function (error) {
            console.log(error)
          });
        }
      },

      
      Successsub(){
        this.loading=true
        var _this=this
        _this.hasErrors.cmptype=false;
        _this.hasErrors.shopnm=false;
        _this.hasErrors.shopad1=false;
        _this.hasErrors.shopad2=false;
        _this.hasErrors.shoppin=false;
        _this.hasErrors.shop_gst=false;
        _this.hasErrors.shopph=false;
        _this.hasErrors.shopadmin=false;
        _this.hasErrors.shopcntry=false;
        _this.hasErrors.shopstate=false;
        _this.hasErrors.shopcity=false;
        _this.hasErrors.shopnmexist=false;
        var submit_true=0;
        var regex=/^[a-zA-Z0-9\s,.'-/]{3,}$/
        var prex=/^[0-9]{10,15}$/
        var pirex=/^[0-9]{6}$/
        var eregex= /^[a-z][a-zA-Z0-9_]*(\.[a-zA-Z][a-zA-Z0-9_]*)?@[a-z][a-zA-Z-0-9]*\.[a-z]+(\.[a-z]+)?$/
        if(this.shoptype.length==0){
          _this.hasErrors.cmptype=true;
          submit_true=1;
        }
        if (regex.test(this.shop.name)==false){
          _this.hasErrors.shopnm=true;
          submit_true=1
        }
        if(regex.test(this.shop.address1)==false){
          _this.hasErrors.shopad1=true;
          submit_true=1
        }
        // if(this.adminuser==null){
        //   _this.hasErrors.shopadmin=true
        //   submit_true=1;
        // }
        if(this.con==null){
          _this.hasErrors.shopcntry=true
          submit_true=1;
        }
        if(this.state==null){
          _this.hasErrors.shopstate=true
          submit_true=1;
        }
        if(this.city==null){
          _this.hasErrors.shopcity=true
          submit_true=1;
        }
        if( pirex.test(this.shop.pincode)==false){
          _this.hasErrors.shoppin=true;
          submit_true=1
        }
        if(regex.test(this.shop.gst)==false && this.shop.gst!=''){
          _this.hasErrors.shop_gst=true;
          submit_true=1
        }
        if (prex.test(this.shop.phone)==false){
          _this.hasErrors.shopph=true;
          submit_true=1
        }

        if(submit_true==0){
          
          var useradmin=null
          var shp_username=null
          var shp_userphone=null
          // if(this.adminuser !== null){
          //   useradmin=this.adminuser.email
          //   shp_username=this.adminuser.username
          //   shp_userphone=this.adminuser.phone
          // }

          var shop={
            est_type:this.shoptype,
            est_shop_name:this.shop.name,
            est_shop_phone:this.shop.phone,
            address1:this.shop.address1,
            address2:this.shop.address2,
            pincode:this.shop.pincode,
            country_code:this.con.id,
            state_code:this.state.id,
            city:this.city.id,
            shop_gst:this.shop.gst,
            saleprice:this.shop.sale_price_editable,
            est_latitude:this.center.lat,
            est_longititude:this.center.lng,
            shopid:this.shopid,
            user_admin:useradmin,
            shpusername:shp_username,
            shpuserphone:shp_userphone,
            // oldadmin:this.oldadmin,
          }
          
          
          this.$http.post('/api/shopestablishments', shop).then(function(response){
            _this.loading=false
            _this.reset();
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
            _this.$store.commit('set_shopmodal', response.data.est_shop_id)
            _this.largeModal=false;
          }).catch(function(error){
            _this.$store.commit('set_shopmodal', '')
            _this.loading=false
          })
        }
        else{
          _this.loading=false
        }
      },

      setPlace(place) {
        this.position=[];
        this.buttosstat=0;
        this.place = place;
        this.center={lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng()};
      },
      
      usePlace(place) {
        this.buttosstat=1
        this.markers=[]
        if (this.place) {
          this.markers.push({
            position: {
              lat: this.place.geometry.location.lat(),
              lng: this.place.geometry.location.lng(),
            }
          })
          this.place=null;
        }else{
          this.markers=[{position:{lat:this.center.lat, lng:this.center.lng}}]
        }
      },

      revertbck(){
        this.largeModal=true;
        this.warningModal=false;
      },

      reset(){
        var _this=this;
        _this.shop.name ='';
        _this.con=null,
        _this.state = null;
        _this.city = null;
        _this.shoptype=null;
        _this.shop.address1 = '' ;
        _this.shop.address2 = ''; 
        _this.shop.pincode = ''; 
        _this.shop.gst = '' ;
        _this.shop.phone = ''; 
      },

    },
    beforeMount() {
    // here we need to listen for emited events
    // we declared those events inside our plugin
      shopModal.EventBus.$on('showShop', (params) => {
        this.showShop(params)
      })
  }
}
</script>


// WEBPACK FOOTER //
// src/views/setting/AddShopModal.vue